<template>
  <transition name="bounce">
    <div v-if="phone_number_exist" id="box-phone" class="email-box">
      <div style="display: flex; padding: 0">
        <select id="country-code" v-model="country_code" name="country-code">
          <option value="" selected disabled hidden>
            Choose
          </option>
          <option
            v-for="item in select_items"
            :key="item.id"
            :value="item"
            style="font-size: 11px; background-color: green"
          >
            {{ item.country }} ({{ item.dialing_code }})
          </option>
        </select>
        <input
          v-model.trim="phone"
          type="email"
          class="email"
          :placeholder="$t('whatsapp_messaging.placeholder_phone')"
        />

        <button
          class="phoneNumberButton"
          :disabled="!phone || !country_code || loading"
          style="margin-left: 10px"
          @click="submit"
        >
          <div v-if="loading" class="lds-dual-ring"></div>
          <span v-else>{{ $t(button) }}</span>
        </button>
      </div>
      <p v-if="error" style="margin-left: 20px; color: #ff6961">
        {{ $t("whatsapp_messaging.error_message") }}
      </p>
      <p v-if="success" style="margin-left: 20px; color: green">
        {{ $t("whatsapp_messaging.success") }}
      </p>
    </div>
  </transition>
</template>

<script>
import json from "../assets/countries.json";
import { customLogger } from "@/utils";
const store_utils = require("@/store_utils").default;
export default {
  name: "BoxPhone",
  components: {},
  props: {},
  data: () => {
    return {
      phone: "",
      country_code: null || "",
      button: "OK",
      error: false,
      success: false,
      select_items: json,
      phone_number_exist: true,
      loading: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async submit() {
      this.loading = true;
      this.error = false;
      this.success = false;
      let cc = this.country_code.country_code,
        dc = this.country_code.dialing_code,
        phone = this.phone;
      let params = { cc, phone };
      let save_params = { dc, phone };
      try {
        const checkNumber = await this.$store.dispatch(
          "CHECK_PHONE_NUMBER",
          params
        );
        if (checkNumber) {
          //customLogger(dc)
          await this.$store.dispatch("SAVE_PHONE_NUMBER", save_params);
          this.success = true;
          this.phone_number_exist = false;
          store_utils.emit_message({
            message: params.phone,
            dialogflow: true,
            commit: true,
            sender: "self",
          });
          store_utils.emit_message({
            message: "whatsapp_messaging.init_store_conversation",
            dialogflow: true,
            commit: true,
            sender: "bot",
            typing: true,
          });
          this.loading = false;
        } else {
          throw "phone_number insertion failed";
        }
      } catch (e) {
        this.error = true;
        this.loading = false;
        return e;
      }
    },
  },
};
</script>
